const SplashLoader: React.FC = () => {
  return (
    <div className="flex space-x-2 justify-center items-center bg-white h-dvh dark:invert">
      <div className="h-8 w-8 bg-black rounded-full animate-bounce [animation-delay:-0.3s]"></div>
      <div className="h-8 w-8 bg-black rounded-full animate-bounce [animation-delay:-0.15s]"></div>
      <div className="h-8 w-8 bg-black rounded-full animate-bounce"></div>
    </div>
  );
};

export default SplashLoader;
